import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateInspectionServiceOperationHours } from '../../api/inspection-service.ts';
import { UpdateInspectionServiceOperationHoursRequest } from '../../api/requests/inspection-service-request.ts';

export default function useUpdateInspectionServiceOperationHours(): UseMutationResult<
  Awaited<ReturnType<typeof updateInspectionServiceOperationHours>>,
  Error,
  UpdateInspectionServiceOperationHoursRequest
> {
  return useMutation({
    mutationFn: updateInspectionServiceOperationHours,
  });
}
